<template>
  <div class="charging-point-search pa-10">

    <title-page icon="ico-charging-point">
      Analyse des charges
    </title-page>


    <v-row>
      <v-col>
        <v-data-table
            :headers="headers"
            :items="items"
        >
          <template #item.identifier="{item}">
            <router-link :to="{name: 'charging-points.detail.discontinuities', params: {id: item.id}}" target="_blank">{{ item.identifier }}</router-link>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

  </div>
</template>

<script>


import ChargingPointRepository from "@repository/ChargingPointRepository";

export default {
  name: 'ChargingPointSearch',

  data() {
    return {
      month: '2025-02',
      items: [],
      headers: [
        {text: 'Identifier', value: 'identifier'},
        {text: 'Name', value: 'name'},
        {text: 'missing', value: 'missing'},
        {text: 'duplicated', value: 'duplicated'},
      ],
    }
  },

  mounted() {
    if(!this.currentUser.permissions.includes('OPERATOR_WRITE')) {
      this.$router.replace({name: 'dashboard'})
      return null
    }

    this.loadData()
  },


  methods: {
    loadData() {
      this.showLoading(true)
      ChargingPointRepository.meterDiscontinuities(this.month).then(result => {
        this.items = result.map(item => ({
          ...item,
          missing: item.missing.length,
          duplicated: item.duplicated.length,
        }))
        this.showLoading(false)
      }).catch(err => {
        this.notifyError(err)
        this.showLoading(false)
      })
    }
  }

}
</script>

<style lang="scss">

</style>